<template>
  <div>
    <input-with-validation :disabled="readOnly" ref="input" :vid="randomVid" :field-label="$attrs.label" :rules="rules" :placeholder="placeholder" b-name="input" type="textarea" v-model="model"></input-with-validation>
  </div>
</template>

<script>
import ElementRendererMixin from "@/components/form_builder/ElementRendererMixin";
import InputWithValidation from "@/components/validation/InputWithValidation";

export default {
  name: "TextareaElementRenderer",
  components: {InputWithValidation},
  mixins: [ElementRendererMixin]
}
</script>

<style scoped>

</style>
